import type { FunctionComponent, ReactNode } from "react";

import IconLine from "./icon-line.svg";
import IconWifi from "./icon-wifi.svg";
import { Container, Footer, Frame, FrontCamera, Header, Wrapper } from "./styles";

export type Props = {
  children: ReactNode;
  className?: string;
};

export const DeviceFrameset: FunctionComponent<Props> = ({ children, className }) => (
  <Container className={className}>
    <Wrapper>
      <Header>
        19:03
        <FrontCamera />
        <IconWifi />
      </Header>
      <Frame>{children}</Frame>
      <Footer>
        scmp.com
        <IconLine />
      </Footer>
    </Wrapper>
  </Container>
);

DeviceFrameset.displayName = "DeviceFrameset";
